import React, { Component } from 'react';
import { Form } from './Form';
import { Confirmation } from './Confirmation';
import { Inform } from './Inform';
import data from '../../services/data';
import './stylesSEEL.css';
import ReactLoading from 'react-loading';

export default class Inscricoes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phase: 0,
            serverResponse: null, // from backend.php
            formData: null, // from config.php
            initialState: null,
            loading: true
        }
    }

    async componentDidMount() {
        this.setState({ loading: true });
        const fetch = await data.get(`config.php?resource=all`);
        this.setState({ formData: fetch.data });
        this.setState({ loading: false })
    }

    handleSubmit = async (e, data2send) => {
        e.preventDefault();
        this.setState({ loading: true });

        const postTo = "backend.php" + (this.state.phase === 1 ? "?send=y" : "");
        const serverResponse = await data.post(postTo, data2send);
        this.setState({
            phase: 1,
            serverResponse: serverResponse.data,
        });

        this.setState({ loading: false });
    }

    voltar = (data) => {
        this.setState({
            phase: 0,
            initialState: data,
        });
    }

    render() {
        return (<div id="enrollment-container">
            {this.state.formData &&
                <header><span> {this.state.formData.msg.header} </span></header>}

            {this.state.loading &&
                <ReactLoading type="bubbles" color="gray" height={50} width={50} />}

            {this.state.phase === 0 && this.state.formData &&
                <Form handleSubmit={this.handleSubmit} {...this.state} />}

            {this.state.phase === 1 && this.state.serverResponse && !("error" in this.state.serverResponse) && !("inform" in this.state.serverResponse) &&
                <Confirmation handleSubmit={this.handleSubmit} voltar={this.voltar} {...this.state} />}

            {this.state.serverResponse && ("error" in this.state.serverResponse || "inform" in this.state.serverResponse) &&
                <Inform {...this.state} />}

            <footer>por <a href="mailto:bressanmarcos@alu.ufc.br">@bressanmarcos</a></footer>
        </div>
        );
    }
}
